export const DeleteCompanyOption = (index, companiesName, companiesId, setCompaniesName, setCompaniesId) => {
  let arrayName = [...companiesName];
  let arrayId = [...companiesId];
  let newIndex = index;
  if (newIndex !== -1) {
    arrayName.splice(newIndex, 1);
    setCompaniesName(arrayName);
    arrayId.splice(newIndex, 1);
    setCompaniesId(arrayId);
  }
};
